<template>
  <div id="Blog">
    <Navbar :setorders="orders" :booking="setbooking" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-4">col-sm-8</div>
        <div class="col-sm-8">col-sm-4</div>
      </div>
    </div>

    <div class="space"></div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "../layouts/navbar.vue";
import Footer from "../layouts/footer.vue";
import axios from "axios";
// import $ from "jquery";
import moment from "moment";
export default {
  components: { Navbar, Footer },
  name: "Blog",
  data() {
    return {
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      orders: [],
      readMore: {},
      show: false,
      orderMore: {},
      disable: false,
      setbooking: [],
      loggedIn: false,
      code: "",
      auth: [],
      time: null,
    };
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
  },
  filters: {
    moment: function (date) {
      moment.locale("th");
      return moment(date).add(543, "year").format("LL");
    },
  },
  mounted() {
    if (localStorage.getItem("auth") != null) {
      this.auth = JSON.parse(localStorage.getItem("auth"));
      this.code = this.auth.std_code;
      // let tran = JSON.parse(localStorage.getItem("orders"));
      // console.log(tran);
    }
    if (localStorage.getItem("orders") == null) {
      this.getorder();
    } else {
      setInterval(() => {
        this.getorder_timeout();
      }, 5000);
    }

    if (localStorage.getItem("orders") != null) {
      this.loadOrder();
      this.show = true;
    }

    if (localStorage.getItem("booking") != null) {
      this.setbooking = JSON.parse(localStorage.getItem("booking"));
    }
  },
  methods: {
    moment: function () {
      return moment();
    },
    getorder() {
      let data = {
        token: this.token,
        std_code: this.code,
      };
      const headers = {
        "content-type": "application/json",
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/getorder", data, {
          headers,
        })
        .then((res) => {
          if (res.data.Orders !== null) {
            this.orders = res.data.Orders;
            if (localStorage.getItem("maxchk") != null) {
              // qty_borrow_max
              localStorage.setItem("maxchk", res.data.qty_borrow_max);
            }
            localStorage.setItem("orders", JSON.stringify(this.orders));

            this.show = true;
            this.$isLoading(false);
          }
        });
    },
    getorder_timeout() {
      let data = {
        token: this.token,
        std_code: this.code,
      };
      const headers = {
        "content-type": "application/json",
      };
      // this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/getorder", data, {
          headers,
        })
        .then((res) => {
          if (res.data.Orders !== null) {
            this.orders = res.data.Orders;
            // console.log(this.orders);
            if (localStorage.getItem("maxchk") != null) {
              // qty_borrow_max
              localStorage.setItem("maxchk", res.data.qty_borrow_max);
            }
            localStorage.setItem("orders", JSON.stringify(this.orders));

            this.show = true;
          }
        });
    },
    loadOrder() {
      this.orders = JSON.parse(localStorage.getItem("orders"));
    },
    showMore(id) {
      this.$set(this.readMore, id, true);
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
    orderShowMore(id) {
      this.$set(this.orderMore, id, true);
    },
    orderShowLess(id) {
      this.$set(this.orderMore, id, false);
    },
  },
};
</script>

<style scoped>
.space {
  height: 300px;
}
</style>
